<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('mobileApp.helpCenterSectionTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_help_center: 'add_help_center'
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addHelpCenterButton="true"
          :openAddHelpCenterModal="openAddHelpCenterModal"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          :hideBranch="true"
        ></preDatatableComponent>

        <div class="col-xs-12">
          <div class="row" style="margin-bottom: 10px; padding-left: 15px; padding-right: 15px;">
            <v-flex xs12 sm4 md3>
              <v-select
                :label="$t('helpCenter.displayLanguageLabel')"
                :items="languageOptions"
                v-model="displayLanguage"
                dense
              ></v-select>
            </v-flex>
          </div>

          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.help_center_id"
              >
                <td>{{ r.help_center_id }}</td>
                <td>
                  <span v-if="questionFor(r) && questionFor(r).length > 70">
                    {{ questionFor(r).slice(0, 70) + '...' }}
                  </span>
                  <span v-else>
                    {{ questionFor(r) }}
                  </span>
                </td>
                <td>
                  <span v-if="answerFor(r) && answerFor(r).length > 70">
                    {{ answerFor(r).slice(0, 70) + '...' }}
                  </span>
                  <span v-else>
                    {{ answerFor(r) }}
                  </span>
                </td>
                <td>{{ r.order }}</td>
                <td>
                  <v-switch
                    v-model="r.is_active"
                    :input-value="r.is_active"
                    @change="updateActive(r)"
                    color="success"
                    inset
                  ></v-switch>
                </td>
                <td>{{ r.created_at | moment('YYYY-MM-DD h:mm A') }}</td>
                <td>
                  <a
                    v-if="$_has_perm('edit_help_center')"
                    :tooltip="$t('common.edit')"
                    @click="openEditHelpCenterModal(r)"
                  >
                    <v-icon color="blue darken-2">edit</v-icon>
                  </a>
                  <a
                    v-if="$_has_perm('delete_help_center')"
                    :tooltip="$t('common.delete')"
                    @click="deleteHelpCenter(r.help_center_id)"
                  >
                    <v-icon color="red darken-2">delete</v-icon>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <add-edit-help-center
            :addEditHelpCenterModal="addEditHelpCenterModal"
            :formData="formData"
            :isUpdate="isUpdate"
            @close="addEditHelpCenterModal = false"
            @resetTable="resetGetResults()"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import addEditHelpCenter from './addEditHelpCenter.vue'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    addEditHelpCenter
  },
  mounted() {
    this.perPageFix()
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'help_center_id' },
      {
        label: this.$t('columns.question'),
        text: this.$t('columns.question'),
        value: '2',
        sortable: false,
        searchable: false,
        name: 'question'
      },
      {
        label: this.$t('columns.answer'),
        text: this.$t('columns.answer'),
        value: '3',
        sortable: false,
        searchable: false,
        name: 'answer'
      },
      {
        label: this.$t('columns.order'),
        text: this.$t('columns.order'),
        value: '4',
        sortable: true,
        searchable: true,
        name: 'order'
      },
      {
        label: this.$t('common.active'),
        text: this.$t('common.active'),
        value: '5',
        sortable: true,
        searchable: true,
        name: 'is_active'
      },
      {
        label: this.$t('columns.createDate'),
        text: this.$t('columns.createDate'),
        value: '6',
        sortable: true,
        searchable: true,
        name: 'created_at'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/help-center',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditHelpCenterModal: false,
      prevSearchQuery: '',
      apiResults: [],
      displayLanguage: 'en',
      formData: {
        order: 1,
        is_active: true,
        question_en: '',
        question_ar: '',
        question_ku: '',
        answer_en: '',
        answer_ar: '',
        answer_ku: ''
      },
      languageOptions: [
        { text: this.$t('helpCenter.englishEnOption'), value: 'en' },
        { text: this.$t('helpCenter.arabicArOption'), value: 'ar' },
        { text: this.$t('helpCenter.kurdishKuOption'), value: 'ku' }
      ],
      columns: columns,
      sortKey: 'help_center_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order',
        sortDir: 'asc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    questionFor(row) {
      return row[`question_${this.displayLanguage}`] || row.question_en || ''
    },

    answerFor(row) {
      return row[`answer_${this.displayLanguage}`] || row.answer_en || ''
    },

    updateActive(data) {
      let token = localStorage.getItem('access_token')

      axios.put(`api/help-center/${data.help_center_id}`, data, {
        headers: { Authorization: 'Bearer ' + token }
      })
        .then(() => {
          swal({
            title: this.$t('common.updatedSuccessfully'),
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
          this.getResults()
        })
        .catch((error) => {
          swal(this.$t('common.error'), error.response.data.message, 'error')
        })
    },

    openAddHelpCenterModal() {
      this.formData = {
        order: 1,
        is_active: true,
        question_en: '',
        question_ar: '',
        question_ku: '',
        answer_en: '',
        answer_ar: '',
        answer_ku: ''
      }
      this.isUpdate = false
      this.addEditHelpCenterModal = true
    },

    openEditHelpCenterModal(data) {
      this.formData = { ...data }
      this.isUpdate = true
      this.addEditHelpCenterModal = true
    },

    deleteHelpCenter(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios.delete(`api/help-center/${id}`, { headers: { Authorization: 'Bearer ' + token } }).then(() => {
            this.getResults()
            swal({
              title: this.$t('common.deletedSuccessfully'),
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            })
          }).catch((error) => {
            swal(this.$t('common.error'), error.response.data.message, 'error')
          })
        }
      })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          if (theDatatable != null) {
            theDatatable.classList.remove('slide-table-out')
            setTimeout(function () {
              thePanel.style.overflowX = 'auto'
            }, 0)
          }
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { console.error(errors) })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'help_center_id'
      this.tableData.sortDir = 'asc'
      this.tableData.column = 'order'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'help_center_id'
      this.tableData.sortDir = 'asc'
      this.tableData.column = 'order'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.displayLanguage = 'en'
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  border-radius: 3px;
  box-shadow: 0px 0px 2px #484b4e;
  background: #484b4e;
}
</style>



// WEBPACK FOOTER //
// src/components/helpCenter/helpCenter.vue